import React, { useEffect } from 'react';
import block from 'propmods';
import { Spin } from 'lego-on-react';

const b = block('AsyncProgress');

interface Props {
    action(payload?: unknown): Promise<unknown>;
}

const AsyncProgress: React.FC<Props> = ({ action }) => {
    useEffect(() => {
        const doAsync = async () => {
            return await action();
        };
        doAsync().catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div {...b('progress')}>
            <Spin size="l" />
        </div>
    );
};

export default AsyncProgress;
